// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5989 ? "4a8d1277" : chunkId) + "." + {"4416":"b02d1c702dcb5f6d","5451":"f262e601d043cbfa","5989":"9c1645f2fc22d6b7","6019":"cce25fc3ba19d9f8","6740":"fed9209c91bdb469","7138":"12d2eedf05e1e572","7347":"b12ed81484ba981f","8395":"fe679868e5adab44","8463":"ac11c0fc5f875c89"}[chunkId] + ".js";
};